<template>

  <div>

    <b-modal v-model="hasGeneralErrors" id="modalGeneralErrors" title="Erros encontrados:" ok-only>

      <div v-for="error in generalErrors" :key="error" class="p-2 border-bottom mb-2">
        <span class="text-danger">
          <b-icon-x-circle-fill class="mr-2"/>
          <span v-html="error.replace(/\n/g,'<br />')"></span>
        </span>
      </div>

      <template #modal-footer="{ ok }">

        <t-button @click="ok()" text="Corrigir Erros" danger/>

      </template>

    </b-modal>

    <transition mode="out-in"
                enter-active-class="animated fadeInFast">
      <b-col v-show="!busy" class="fadeIn mb-2 list-table-transition" cols="12">

        <transition name="fade-fast">

          <div v-show="checkValidation()">

            <validation-observer ref="validationFormList" v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

              <form @submit.prevent="onSubmit" ref="formList">

                <t-form-wrapped :command="command" :status="localStatus">

                  <b-row style="margin-left: -5px; margin-right: -5px;" :class="{'form-loading':busyForm}">
                    <slot :status="localStatus"></slot>
                  </b-row>

                </t-form-wrapped>

              </form>

            </validation-observer>

          </div>

        </transition>


        <div v-if="items && items.length > 0 && !hideHeader" class="d-flex border form-list-header align-items-center">

          <span v-if="sortable" style="width: 45px" v-b-tooltip.hover title="Alterar order da listagem"></span>
          <span v-else style="width: 20px"></span>


          <div class="text flex-grow-1">
            <b-row>
              <div class="col col-sm-12" v-for="field in fields.filter((a) => {return 'label' in a})" :key="field.key"
                     :class="{['col-md-'+field.cols]:field.cols!=='','text-right':field.align === 'right','text-center':field.align === 'center'}">
                {{ field.label }}
              </div>
            </b-row>
          </div>

          <span :style="{'width': headerMarginRight}"></span>

        </div>


        <div v-show="!busyList">

          <slot name="list-container">

            <div class="list-group" :class="{'hideHeader':hideHeader}">

              <!--Aplica a classe somente para evitar quebra de 2 listas ordenável e não ordenável -->
              <draggable :list="items"
                         @end="draggableEnd" handle=".handle">

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">

                  <li
                      class="list-group-item list-group-item-form-list line-hover"
                      :class="item.class"
                      v-for="(item,index) in items"
                      :key="item[primaryKeyColumn]">

                    <div class="d-flex align-content-center" style="word-break: break-word">

                      <b-icon-justify
                          v-if="(sortable && sortableCheckColumn === '') || (sortable && item[sortableCheckColumn])"
                          class="z-index-6 mr-2 mt-1 move handle" style="scale:1.2" v-b-tooltip.hover title="Alterar order da listagem"/>
                      <b-icon-justify v-else-if="sortable" class="z-index-6 mr-2 mt-1 opacity-1"
                                      style="scale:1.2"/>


                      <div class="text flex-grow-1 mr-3" style="word-break: break-word">

                        <b-row class="align-content-center">

                          <slot name="list-content" :item="item" :index="index">

                            <b-col
                                :key="field[keyRead]"
                                v-for="field in fields.filter((a) => {return 'label' in a})"
                                class="col-sm-12"
                                :class="{['col-md-'+field.cols]:field.cols>0,'text-right':field.align === 'right','text-center':field.align === 'center'}">

                              <slot :name="'item(' + field.key + ')'" :item="item">
                                <t-table-field :column="field.key" :item="item" :formatter="field.formatter"/>
                              </slot>

                            </b-col>

                          </slot>

                        </b-row>

                      </div>


                      <div>
                        <slot name="list-buttons" :item="item"></slot>
                      </div>

                      <div v-if="enableChangeOrderUpDown && userAuth.validation.validationUpdate" style="min-width: 45px" class="d-flex justify-content-end align-content-center">

                        <b-icon-arrow-up-square v-show="index > 0" @click="changeOrderByType(item[primaryKeyColumn],'Up')"
                                                class="opacity-6-hover mt-1 mr-2 hover"/>

                        <b-icon-arrow-down-square v-show="index !== (items.length-1)" @click="changeOrderByType(item[primaryKeyColumn],'Down')"
                                                  class="opacity-6-hover mt-1 mr-2 hover"/>

                      </div>

                      <div style="min-width: 50px" v-if="!disableDefaultButtons">

                        <slot name="append-default-buttons" :item="item"></slot>

                        <t-button outline-focus small class="mt-1 mr-2" v-if="userAuth.validation.validationUpdate" @click="itemRead(item[keyRead])"> <b-icon-pencil-square />Editar</t-button>

                        <t-button outline-danger small class="mt-1" v-if="userAuth.validation.validationDelete" @click="itemDelete(item[keyDelete])"> <b-icon-x-circle class="mr-1"  />Excluir</t-button>

                      </div>


                    </div>

                    <slot name="list-footer" :item="item"></slot>

                  </li>

                </transition-group>

              </draggable>

              <div v-if="!disableFooterLength && items !== undefined && items !== null && items.length > 0 && !pageable" class="text-right mt-1">Qtd. itens: <strong>{{ items.length }}</strong> <t-help title="Qtd. de itens diferentes na listagem, independente da quantidade individual de cada item." /></div>

            </div>

          </slot>

          <b-row v-if="totalPages > 0 && pageable" class="mt-3">

            <b-col cols="6">
              <t-pagination v-if="totalPages > 1" @getPage="clickPage" not-link-gen
                            :total-pages="totalPages"></t-pagination>
            </b-col>
            <b-col :cols="totalPages === 1 ? 12 : 6" v-if="totalElements > 0" class="text-right mt-2">
              <small>Total {{ totalElements }} {{ localTitleItems }}</small>
            </b-col>

          </b-row>



        </div>

        <div class="container_loading_form" v-show="busyList">

          <div class="container_loading_form_card" style="height: 350px">

            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>

          </div>

        </div>

      </b-col>

    </transition>

    <div class="container_loading_form" v-show="busy">

      <div class="container_loading_form_card" style="height: 350px">

        <div class="gradient element-100" style="height: 50px"></div>

        <div class="gradient element-100" style="height: 30px"></div>

        <div class="gradient element-100" style="height: 100px"></div>

      </div>

    </div>


  </div>

</template>
<script>
import ui from "@/assets/scripts/ui"
import http from "@/services/config/http-common";

export default {
  name: 't-form-list',
  data() {
    return {
      hasGeneralErrors: false,
      drag: false,
      localStatus: "",
      errorList: [],
      isInvalid: false,
      keyRead: "",
      keyDelete: "",
      columnSize: 0,
      dragging: false,
      localTitleItems: "",
    }
  },
  props: {
    generalErrors: [],
    status: String,
    command: {
      type: String,
      default: 'insert'
    },
    changeOrderParams:{
      type:String,
      default:"",
    },
    title: String,
    userAuth: Object,
    items: [],
    fields: [],
    headerMarginRight:{
      type: String,
      default: '75px',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    sortable: Boolean,
    disableDefaultButtons: Boolean,
    enableChangeOrderUpDown:Boolean,
    disableFooterLength:Boolean, //Desabilitar exibição do totalizador de itens da listagem
      sortableCheckColumn: {
      type: String,
      default: "",
    }, //Usado quando somente alguns itens da listagem são ordenáveis para isso deverá analisar qual campo se for true será sortable
    path: String,
    primaryKey: Number,//Enviar quando desejar reordenar listagem
    foreignKey: Number,//Enviar quando desejar reordenar listagem
    primaryKeyColumn: String,//Enviar quando desejar reordenar listagem
    foreignKeyColumn: String,//Enviar quando desejar reordenar listagem
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
    busyForm: {//busy somente do formulário na parte superior
      type: Boolean,
      default: false,
    },
    busyList: {//busy somente da listagem
      type: Boolean,
      default: false,
    },
    titleItems: {
      type: String,
      default: ""
    },
    pageable:Boolean,
    totalPages: {
      type: Number,
      default: 0
    },
    totalElements: {
      type: Number,
      default: 0
    },
  },
  mounted() {

    this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    this.keyRead = this.fields[0].keyRead
    this.keyDelete = this.fields[0].keyDelete
    this.localStatus = this.status

    if (this.titleItems !== '') {
      this.localTitleItems = this.titleItems
    } else {

      if (this.userAuth && this.userAuth.currentPage && this.userAuth.currentPage.singularTitle) {
        this.localTitleItems = this.userAuth.currentPage.singularTitle + "s"
      } else {
        this.localTitleItems = 'registros'
      }
    }

  },
  computed: {


    onSending() {
      return this.status === "sending"
    },


  },
  methods: {

    checkValidation() {
      //return ui.hasValidation(this.command,this.userAuth.validation)

      return ((this.command === 'insert' && this.userAuth.validation.validationCreate) ||
          (this.command === 'update' && this.userAuth.validation.validationUpdate) ||
          (this.command === 'delete' && this.userAuth.validation.validationDelete) ||
          (this.command === "view" && this.userAuth.validation.validationRead))

    },

    itemRead(id) {
      this.$emit('onItemRead', id)

    },
    itemDelete(id) {

      ui.msgConfirmDelete(this, () => {
        this.$emit('onItemDelete', id)
      })

    },
    setReset() {

    },

    orderItemsReduce() {

      let newListOrder = []


      for (const item of this.items) {

        if (this.sortableCheckColumn === '' || item[this.sortableCheckColumn])
          newListOrder.push(item[this.primaryKeyColumn])

      }

      return {
        id: this.foreignKey,
        orderList: newListOrder
      }

    },

    changeOrderByType(id, type){


      let url = this.path + "/change"+type +"/"+id

      if (this.changeOrderParams !== '') {
        url += `?${this.changeOrderParams}`
      }

      http.get(url).then(() => {

        this.$emit("onChangeOrder") //Enviar para o componente principal informando que houve atualização na listagem

        //Atualiza os indices conforme nova ordem
        ui.toast(this, "Ordem atualizada!", "Ordem alterada com sucesso")

      }).catch(async (error) => {
        ui.generalResponseError(this,error)
      })

    },

    draggableEnd() {

      if (this.sortable) {

        let url = this.path + "/changeOrder"

        if (this.changeOrderParams !== '') {
          url += `?${this.changeOrderParams}`
        }

        http.post(url, this.orderItemsReduce()).then(() => {

          this.$emit("onChangeOrder") //Enviar para o componente principal informando que houve atualização na listagem

          //Atualiza os indices conforme nova ordem
          ui.toast(this, "Ordem atualizada!", "Ordem alterada com sucesso")

        }).catch(async () => {
          this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
          ui.msgError(this, "Erro ao tentar atualizar a ordem das imagens. Tente novamente e caso o problema persistir informe nosso suporte técnico.");
        })

      }

    },
    onSubmit() {

      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"
      //this.$parent.status = "subject"

      this.$refs.validationFormList.validate().then(success => {

        //Bloqueia somente se não tiver tentato enviar nenhuma vez, depois disso será por conta do backend, pois
        if (!success && this.status === '') {
          return;
        }

        //console.log('Form validação básica padrão passou!')

        this.$emit('onSubmit')


      });

    },
    setSending() {
      this.status = "sending"
    },

    reload() {
      this.$emit("reload")
    },

    clickPage(page) {
      this.$emit('getPage', page)
    },

  },
  watch: {

    status(value) {
      this.localStatus = value
    },
    generalErrors() {
      this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    },
  }
}
</script>
<style>

</style>
